// src/components/FormIndicator.jsx
import React from 'react';

/**
 * FormIndicator - Displays last N results as W/L/D indicators
 * @param {Array} results - Array of result objects with 'result' property ('W', 'L', or 'D')
 * @param {number} maxResults - Maximum number of results to display (default: 5)
 */
export default function FormIndicator({ results = [], maxResults = 5 }) {
  // Take last N results
  const displayResults = results.slice(-maxResults);

  // If no results, show placeholder
  if (displayResults.length === 0) {
    return (
      <div className="flex gap-1">
        {[...Array(maxResults)].map((_, i) => (
          <div
            key={i}
            className="w-4 h-4 sm:w-6 sm:h-6 rounded-full bg-gray-200 flex items-center justify-center"
          >
            <span className="text-xs sm:text-xs text-content-secondary">-</span>
          </div>
        ))}
      </div>
    );
  }

  const getResultColor = (result) => {
    switch (result?.toUpperCase()) {
      case 'W':
        return 'bg-green-500 text-white';
      case 'L':
        return 'bg-red-500 text-white';
      case 'D':
        return 'bg-gray-400 text-white';
      default:
        return 'bg-gray-200 text-gray-400';
    }
  };

  return (
    <div className="flex gap-1">
      {displayResults.map((item, index) => {
        const result = typeof item === 'string' ? item : item.result;
        return (
          <div
            key={index}
            className={`w-4 h-4 sm:w-6 sm:h-6 rounded-full flex items-center justify-center ${getResultColor(result)}`}
            title={`Result: ${result || 'Unknown'}`}
          >
            <span className="text-xs sm:text-xs font-semibold leading-none">{result?.toUpperCase() || '-'}</span>
          </div>
        );
      })}
    </div>
  );
}
